// Photos are optimized WebP files served from the CDN (see src/assets/*.asset.json).
const dakkapelImage = "/__l5e/assets-v1/b03e3dfb-683b-43af-b17c-5ec6ef255122/dienst-dakkapel.webp";
const aanbouwImage = "/__l5e/assets-v1/f48723a7-ce5d-4076-884f-8c85ebe51605/dienst-aanbouw.webp";
const renovatieImage =
  "/__l5e/assets-v1/3eecbb62-00a1-4d11-8cb7-affbaadae2db/dienst-renovatie.webp";
const dakkapelRenovatieImage =
  "/__l5e/assets-v1/88731423-8c70-42fd-a57d-d154326bf05c/dienst-dakkapel-renovatie.webp";
const vlonderImage = "/__l5e/assets-v1/05a4431e-1f5a-46aa-a5eb-a11e9a4f371f/dienst-vlonder.webp";
const schuurImage =
  "/__l5e/assets-v1/c722f9ac-ed66-44c9-a44d-21334289bc83/dienst-overkapping.webp";
const kozijnenImage = "/__l5e/assets-v1/81c20b79-8180-489a-856d-a1d89b386c36/dienst-kozijnen.webp";
const dakopbouwImage =
  "/__l5e/assets-v1/28dec292-3a19-46bb-8427-da2b15f03ce4/dienst-dakopbouw.webp";
const specialsImage = "/__l5e/assets-v1/13ee8bb0-0fdd-407c-9eff-98c9ad4d7e32/dienst-specials.webp";

// 768px-brede varianten voor telefoons — dezelfde foto's, ~3x kleiner.
const dakkapelImage768 =
  "/__l5e/assets-v1/e47e09e2-9fca-47f4-8c61-3d301406567f/dienst-dakkapel-768.webp";
const aanbouwImage768 =
  "/__l5e/assets-v1/7fcc498d-6c3b-44c8-8c4b-ecbf1cffb2ed/dienst-aanbouw-768.webp";
const renovatieImage768 =
  "/__l5e/assets-v1/9cfdb98d-63da-400b-b078-752f0455ab78/dienst-renovatie-768-v2.webp";
const dakkapelRenovatieImage768 =
  "/__l5e/assets-v1/7dbfa0de-2156-4a01-84da-2b72815d22db/dienst-dakkapel-renovatie-768.webp";
const vlonderImage768 =
  "/__l5e/assets-v1/bc9408e5-5718-4fc7-a5d8-23c864df1be6/dienst-vlonder-768.webp";
const schuurImage768 =
  "/__l5e/assets-v1/434b70ba-3bb7-430d-85e7-53e59ca95375/dienst-overkapping-768.webp";
const kozijnenImage768 =
  "/__l5e/assets-v1/1dd07c19-1563-42ed-8877-625bc96809ce/dienst-kozijnen-768.webp";
const dakopbouwImage768 =
  "/__l5e/assets-v1/055fe33b-c3ed-4ae1-9c9e-e2a5d7ad31be/dienst-dakopbouw-768.webp";
const specialsImage768 =
  "/__l5e/assets-v1/948b4779-1b35-4755-980e-d0d711e3312a/dienst-specials-768.webp";

export interface Dienst {
  slug: string;
  title: string;
  description: string;
  imageSrc: string;
  imageSrc768: string;
  imageAlt: string;
}

export const diensten: Dienst[] = [
  {
    slug: "dakkapel",
    title: "Dakkapel",
    description:
      "Ieder dakkapel wordt ter plekke op maat gemaakt, zodat het perfect past bij je wensen!",
    imageSrc: dakkapelImage,
    imageSrc768: dakkapelImage768,
    imageAlt: "Op maat gemaakte dakkapel geplaatst door Fedor Timmerwerken",
  },
  {
    slug: "aanbouw",
    title: "Aanbouw",
    description: "Voeg snel meer ruimte toe aan je huis, om te ontspannen of juist om te werken.",
    imageSrc: aanbouwImage,
    imageSrc768: aanbouwImage768,
    imageAlt: "Houten aanbouw aan een woning in Dordrecht",
  },
  {
    slug: "renovatie",
    title: "Renovatie",
    description: "Toe aan verandering? Woon binnenkort in je droomhuis, zonder te verhuizen!",
    imageSrc: renovatieImage,
    imageSrc768: renovatieImage768,
    imageAlt: "Renovatieproject uitgevoerd door Fedor Timmerwerken",
  },
  {
    slug: "dakkapel-renovatie",
    title: "Dakkapel renovatie",
    description: "Vernieuw je bestaande dakkapel voor een frisse look en betere isolatie.",
    imageSrc: dakkapelRenovatieImage,
    imageSrc768: dakkapelRenovatieImage768,
    imageAlt: "Gerenoveerde dakkapel met nieuwe bekleding",
  },
  {
    slug: "vlonder",
    title: "Vlonder",
    description:
      "Verbind je woonkamer met de tuin en stap 's ochtends naar buiten op je eigen terras.",
    imageSrc: vlonderImage,
    imageSrc768: vlonderImage768,
    imageAlt: "Houten vlonder aan een woning met tuin",
  },
  {
    slug: "schuur",
    title: "Schuur & overkapping",
    description: "Bergruimte, werkplaats of tuinkamer — een schuur of overkapping op maat voor jouw tuin.",
    imageSrc: schuurImage,
    imageSrc768: schuurImage768,
    imageAlt: "Op maat gebouwde houten schuur of overkapping in de tuin",
  },
  {
    slug: "kozijnen",
    title: "Kozijnen",
    description: "Verduurzaam je huis met houten of kunststof kozijnen met HR++ glas.",
    imageSrc: kozijnenImage,
    imageSrc768: kozijnenImage768,
    imageAlt: "Nieuwe kozijnen met HR++ glas geplaatst in een woning",
  },
  {
    slug: "dakopbouw",
    title: "Dakopbouw",
    description: "Meer ruimte nodig? Voeg een verdieping toe aan je huis!",
    imageSrc: dakopbouwImage,
    imageSrc768: dakopbouwImage768,
    imageAlt: "Dakopbouw op een woning in aanbouw",
  },
  {
    slug: "specials",
    title: "Specials",
    description: "Fedor Timmerwerken is ervaren in het bouwen van ideeën.",
    imageSrc: specialsImage,
    imageSrc768: specialsImage768,
    imageAlt: "Maatwerk timmerproject van Fedor Timmerwerken",
  },
];

export interface Review {
  quote: string;
  author: string;
  place: string;
}

export const reviews: Review[] = [
  {
    quote:
      "Onze dakkapel is vakkundig geplaatst en perfect afgewerkt. Fedor denkt mee, communiceert helder en houdt zich aan de afspraken.",
    author: "Familie Vermeulen",
    place: "Dordrecht",
  },
  {
    quote:
      "Van het eerste overleg tot de oplevering: netjes, snel en volgens planning. De nieuwe kozijnen maken ons huis stukken comfortabeler.",
    author: "J. van der Berg",
    place: "Dordrecht",
  },
  {
    quote:
      "Fedor heeft onze tuin getransformeerd met een overkapping en vlonder. Echt vakwerk, tot in de kleinste details.",
    author: "S. Jansen",
    place: "Zwijndrecht",
  },
];

export interface ProcesStap {
  nummer: string;
  title: string;
  description: string;
}

export const procesStappen: ProcesStap[] = [
  {
    nummer: "1",
    title: "Overleg ter plaatse",
    description:
      "Bespreek wat je in gedachten hebt. We bekijken de mogelijkheden en maken indien mogelijk direct een inschatting van de verwachte kosten.",
  },
  {
    nummer: "2",
    title: "Afspraken op maat",
    description:
      "Enthousiast over een samenwerking? Dan stellen we een offerte samen en bespreken we de details. Op maat betekent ook: veel keuze in kleur, materiaal en andere elementen.",
  },
  {
    nummer: "3",
    title: "Werk in uitvoering",
    description: "Fedor Timmerwerken gaat hard aan het werk om je ideeën werkelijkheid te maken!",
  },
  {
    nummer: "4",
    title: "Tot de volgende keer",
    description:
      "Wanneer alles naar wens is nemen we afscheid — en zien we je graag terug bij je volgende project.",
  },
];

export const contactInfo = {
  adres: "Sikkelstraat 50, 3319 LJ Dordrecht",
  adresHref: "https://www.google.com/maps/search/?api=1&query=Sikkelstraat+50+3319+LJ+Dordrecht",
  email: "info@fedortimmerwerken.nl",
  emailHref: "mailto:info@fedortimmerwerken.nl",
  telefoon: "06-28130786",
  telefoonHref: "tel:+31628130786",
  whatsappHref: "https://wa.me/31628130786",
};

/** Sociale kanalen — gebruikt in header, footer, actiebalk en JSON-LD. */
export const socials = {
  instagram: {
    label: "Instagram",
    handle: "@fedortimmerwerken",
    href: "https://www.instagram.com/fedortimmerwerken/",
  },
  google: {
    label: "Google Bedrijfsprofiel",
    handle: "Fedor Timmerwerken op Google",
    href: "https://www.google.com/maps/place/?q=place_id:ChIJdakXcIUvxEcRlhis1UYJCNE",
  },
} as const;

/** Directe link om een Google-review te schrijven (versterkt lokale autoriteit). */
export const googleReviewHref =
  "https://search.google.com/local/writereview?placeid=ChIJdakXcIUvxEcRlhis1UYJCNE";

export const socialProfileUrls = [socials.instagram.href, socials.google.href];
